export default __webpack_public_path__ + "static/media/bakerHealth_showcase1.png";